<template>
    <Header></Header>
    <div class="container sub_page _activity">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/activity_left.png" /></i>
                <i class="deco_02 _small blink4"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _small blink_zoom1"><img src="img/b_icon_02.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom4"><img src="img/b_icon_05.png" /></i>
                <i class="deco_05 none_768 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 none_768 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 none_768 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/activity_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>액션 시민 활동</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">반성매매 시민활동</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">캠페인·이벤트</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']" class="w_1024_custom_width">
                        <a href="javascript:void(0)">참여하고 싶은 반성매매 활동 제안</a>
                    </li>
                    <li @click="changeTab(4)" :class="[state.tab === 4 ? 'active' : '']"><a href="javascript:void(0)">액션 시민 활동</a></li>
                </ul>
            </div>
        </section>

        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>

                <span class="icon_wrap"><img src="img/part_icon.png" alt="액션 시민 활동" /></span>
                <router-link :to="{ path: '/board', query: { type: 4 } }">액션 시민 활동</router-link>

                <span class="icon_wrap"><img src="img/part_icon.png" :alt="state.stateInfo.name" /></span>
                <router-link :to="{ path: '/board', query: { type: 4, idx: state.stateIdx } }" style="cursor: default">
                    {{ state.stateInfo.name }}
                </router-link>

                <span class="icon_wrap"><img src="img/part_icon.png" :alt="state.data.title" /></span>
                <a href="javascript:void(0)" style="cursor: default">{{ state.data.title }}</a>
            </div>
            <div class="sub_page_con_view con_view">
                <div class="tit_wrap flex_wrap">
                    <span class="con_tit">{{ state.data.title }}</span>

                    <div class="con_tit_info">
                        <span class="">{{ CommonUtils.dateFormat(new Date(state.data.createDate), ".", true) }}</span>
                        <span class="">
                            <span><img src="img/view.png" alt="" /></span>
                            {{ state.data.viewCnt ? CommonUtils.numberFormat(state.data.viewCnt) : "0" }}
                        </span>
                        <span class="writer_info">
                            <span>작성자</span>
                            {{ state.data.writer }}
                        </span>
                    </div>
                </div>
                <div class="con_table_wrap">
                    <div class="content" v-html="state.data.content"></div>
                    <div class="file_list_wrap" v-if="state.data.fileList != null && state.data.fileList.length > 0">
                        <div class="thum_wrap" v-for="item in state.data.fileList" :key="item.idx">
                            <img class="file_item" :src="item.file" alt="" @click="showImgModal(item.file)" />
                            <button class="common_style" @click="downloadFile(item.file, item.imgRealName)">파일 다운로드</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_wrap _default right_btn">
                <!-- 관리자거나 작성자 본인일때만 조회 -->
                <template v-if="hasAuthForAdmin() || state.data.meIdx === user.userInfo.idx">
                    <button class="common_btn _gray" @click="isDelete">삭제</button>
                    <button class="common_btn" @click="router.push({ name: 'ActionModify', params: { stateIdx: state.stateIdx, id: state.idx } })">
                        수정
                    </button>
                </template>
                <button class="common_btn" @click="router.replace('/board?type=4')">목록</button>
            </div>
        </section>

        <div class="reply_container wrap_1120">
            <div class="tit">댓글 작성</div>
            <div class="reply_wrap">
                <div class="my_reply reply_box">
                    <div class="reply_writer">
                        <img src="img/my_reply.png" alt="" />
                        <input type="text" v-model="form_state.nickName" placeholder="닉네임을 입력해주세요." />
                        <input type="password" v-model="form_state.pw" placeholder="비밀번호를 입력해주세요." />
                    </div>
                    <textarea name="" id="" v-model="form_state.content" class="reply_con custom_scroll"></textarea>
                    <button class="reply_submit" @click="addComment" alt="댓글 등록"><img src="img/reply_uoload.png" alt="" /></button>
                </div>
                <ul class="replies" v-if="state.comments.length > 0">
                    <li class="reply_box" v-for="(item, idx) in state.comments" :key="idx">
                        <template v-if="!state.isMobile">
                            <div class="reply_writer" v-if="!item.isAdmin">
                                <img src="img/reply.png" alt="" />
                                {{ item.nickname }}
                            </div>
                            <div class="reply_writer" v-else>
                                <img src="img/symbol.png" alt="" />
                                다시함께상담센터
                            </div>
                            <div class="reply_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                            <div class="reply_btn" v-if="(item.isAdmin && user.userInfo.isAdmin) || !item.isAdmin">
                                <template v-if="comment_state.idx !== item.idx">
                                    <button type="button" @click="commentModify(item)">수정</button>
                                    <button type="button" @click="confirmCommentRemove(item.idx)" class="_gray">삭제</button>
                                </template>
                                <template v-else-if="comment_state.mode === 'modify' && comment_state.idx === item.idx">
                                    <input
                                        type="password"
                                        v-model="comment_state.pw"
                                        placeholder="비밀번호를 입력해주세요."
                                        v-if="item.meIdx !== user.userInfo.idx && !user.userInfo.isAdmin"
                                    />
                                    <button type="button" @click="commentSave(item)" style="margin-left: 10px">저장</button>
                                    <button type="button" @click="commentCancel()" class="_gray">취소</button>
                                </template>
                            </div>
                            <div class="reply_con" v-html="item.content.replaceAll('\n', '<br>')" v-if="comment_state.idx !== item.idx"></div>
                            <textarea class="reply_con" v-model="comment_state.content" v-else></textarea>
                        </template>
                        <template v-else>
                            <div class="replay_area_for_mobile">
                                <div class="reply_writer" v-if="!item.isAdmin">
                                    <img src="img/reply.png" alt="" />
                                    {{ item.nickname }}
                                </div>
                                <div class="reply_writer" v-else>
                                    <img src="img/symbol.png" alt="" />
                                    다시함께상담센터
                                </div>
                                <div class="reply_area_right">
                                    <div class="reply_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                                    <button
                                        @click="edit(item)"
                                        style="margin-left: 10px"
                                        v-if="(item.isAdmin && user.userInfo.isAdmin) || !item.isAdmin"
                                    >
                                        <img src="img/kebabIcon.png" style="height: 18px; width: auto" />
                                    </button>
                                    <div
                                        class="reply_btn"
                                        v-show="state.isShowBtn && comment_state.idx === item.idx"
                                        :class="state.isShowBtn && comment_state.idx === item.idx ? '_mobile' : ''"
                                    >
                                        <template v-if="comment_state.mode !== 'modify' && comment_state.idx === item.idx">
                                            <button type="button" @click="commentModify(item)">수정</button>
                                            <button type="button" @click="confirmCommentRemove(item.idx)" class="_gray">삭제</button>
                                        </template>
                                        <template v-else-if="comment_state.mode === 'modify' && comment_state.idx === item.idx">
                                            <button type="button" @click="commentSave(item)" style="">저장</button>
                                            <button type="button" @click="commentCancel()" class="_gray">취소</button>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <template v-if="comment_state.mode === 'modify' && comment_state.idx === item.idx">
                                <div style="width: 100%">
                                    <input
                                        type="password"
                                        v-model="comment_state.pw"
                                        placeholder="비밀번호를 입력해주세요."
                                        v-if="item.meIdx !== user.userInfo.idx"
                                    />
                                </div>
                            </template>

                            <div
                                class="reply_con"
                                v-html="item.content.replaceAll('\n', '<br>')"
                                v-if="(comment_state.mode !== 'modify' && comment_state.idx === item.idx) || comment_state.idx !== item.idx"
                            ></div>
                            <textarea class="reply_con" v-model="comment_state.content" v-else></textarea>
                        </template>
                    </li>
                </ul>
                <PageBtn
                    v-if="state.comments.length !== 0"
                    :currentPage="state.page"
                    :totalLength="state.totalLength"
                    :perPage="state.size"
                    @onPaging="handlePageChange"
                ></PageBtn>
            </div>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ModalDefault
        v-if="state.isShowModal2"
        :type="state.modalTab2"
        :title="state.modalTitle2"
        :content="state.modalContent2"
        @close="closeModal2"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        Header,
        Footer,
        types,
        apiService,
        useRoute,
        userStore,
        CommonUtils,
        ModalDefault,
        PageBtn,
        getMessageByCode,
        onBeforeMount,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, PageBtn },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                stateIdx: 0 as number,
                stateInfo: {} as types.ResBoardStateVOForApi,
                tab: 4 as number,
                idx: 0 as number,

                data: {} as types.ResBoardActionVOForApi,
                comments: [] as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowModal2: false as boolean,
                modalTab2: -1 as number,
                modalIsResult2: false as boolean,
                modalTitle2: "alert" as string,
                modalContent2: "" as string,

                page: 1 as number,
                size: 5 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                subMenuOpen: false,
                subMenuName: "액션 시민 활동" as string,

                isMobile: false,
                isShowBtn: false,

                hasAuth: false as boolean,
            });

            const form_state = reactive({
                pw: "" as string,
                nickName: "" as string,
                content: "" as string,
            });

            const comment_state = reactive({
                mode: "" as string,
                idx: 0 as number,
                pw: "" as string,
                content: "" as string,
            });

            const comment_state2 = reactive({
                idx: 0 as number,
            });

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(() => {
                const stateIdx = Number(route.params.stateIdx);
                const idx = Number(route.params.id);

                if (stateIdx && typeof stateIdx === "number" && !isNaN(stateIdx) && user.isLogin()) {
                    state.stateIdx = stateIdx;
                }
                if (idx && typeof idx === "number" && !isNaN(idx)) {
                    state.idx = idx;
                    hasAuth();
                    getStateDetail();
                    getDetail();
                } else {
                    state.modalTab = 7;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "잘못된 접근입니다.";
                    state.isShowModal = true;
                }

                state.isMobile = window.innerWidth < 450;
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    hasAuth();
                    getStateDetail();
                    getDetail();
                },
            );

            const getStateDetail = async () => {
                const res = await apiService.boardAction.stateDetail(state.stateIdx);
                if (res.returnCode === 0) {
                    state.stateInfo = res.data;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeTab = (tab: number) => {
                global.setBoardTab(tab);
                router.push("/board?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민활동";
                        break;
                    case 2:
                        state.subMenuName = "캠페인·이벤트";
                        break;
                    case 3:
                        state.subMenuName = "참여하고 싶은 반성매매 활동 제안";
                        break;
                    case 4:
                        state.subMenuName = "액션 시민 활동";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const getDetail = async () => {
                const res = await apiService.boardAction.detail(state.idx);

                if (res.returnCode === 0) {
                    if (res.data.isSecret === 1 && res.data.meIdx !== user.userInfo.idx && !hasAuthForAdmin()) {
                        confirmModal();
                    } else {
                        state.data = res.data;

                        if (state.data.content) {
                            state.data.content = CommonUtils.decodeContent(state.data.content);
                        }
                        getComments();
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 7;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getConfirm = async (pw: string) => {
                const param: types.ReqConfirmPw = {
                    idx: state.idx,
                    pw: pw,
                };

                const res = await apiService.boardAction.confirmPw(param);
                if (res.returnCode === 0) {
                    state.isShowModal = false;
                    await getDetailWithPw(pw);
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getDetailWithPw = async (pw: string) => {
                const param: types.ReqConfirmPw = {
                    idx: state.idx,
                    pw: pw,
                };

                const res = await apiService.boardAction.confirmDetail(param);
                if (res.returnCode === 0) {
                    state.data = res.data;
                    if (state.data.content) {
                        state.data.content = CommonUtils.decodeContent(state.data.content);
                    }
                    getComments();
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmModal = () => {
                state.modalTab = 3;
                state.modalTitle = "알림";
                state.modalContent = "작성 시 설정한 비밀번호를 입력해주세요.";
                state.isShowModal = true;
            };

            const getComments = async () => {
                const param: types.ReqReportCommentList = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: null,
                };
                const res = await apiService.boardActionComment.list(state.idx, param);

                if (res.returnCode === 0) {
                    state.comments = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.comments = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const addComment = async () => {
                if (!(form_state.pw && form_state.nickName && form_state.content)) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "닉네임, 비밀번호, 내용을 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    if (form_state.content && form_state.content.length > 200) {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = "댓글은 최대 200자 까지 입력이 가능합니다.";
                        state.isShowModal = true;
                    } else {
                        const param: types.ReqBoardActionComment = {
                            nickname: form_state.nickName,
                            pw: form_state.pw,
                            content: form_state.content,
                        };

                        const res = await apiService.boardActionComment.add(state.idx, param);
                        if (res.returnCode === 0) {
                            getComments();
                            form_state.pw = "";
                            form_state.nickName = "";
                            form_state.content = "";
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (!(state.modalTab === 4 || state.modalTab === 5 || state.modalTab === 8 || state.modalTab === 11))
                    router.replace({ path: "/board", query: { type: 4 } });
            };

            const closeModal2 = () => {
                state.isShowModal2 = false;
            };

            const callBackModal = async (param: any) => {
                if (param && param.action) {
                    if (param.action === "confirm") {
                        removeData(state.idx);
                    } else if (param.action === "checkPwForCheck") {
                        commentRemove(param.pw);
                    } else if (param.action === "checkPw") {
                        getConfirm(param.pw);
                    } else {
                        router.back();
                    }
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getComments();
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const isDelete = () => {
                if (user.isLogin()) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 4;
                    state.modalTitle = "비밀번호";
                    state.modalContent = "정말 삭제하시겠습니까?</br> 신고할 때 설정한 비밀번호를 입력해주세요.";
                    state.isShowModal = true;
                }
            };

            const removeData = async (idx: any) => {
                const param: types.ReqIdxList = {
                    idxList: idx,
                };

                const res = await apiService.boardAction.remove(param);
                if (res.returnCode === 0) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const commentModify = (item: any) => {
                comment_state.mode = "modify";

                comment_state.idx = item.idx;
                comment_state.content = item.content;
            };

            const commentSave = async (item: any) => {
                if ((comment_state.pw !== "" && comment_state.pw !== null) || state.hasAuth) {
                    if (comment_state.content && comment_state.content.length > 200) {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = "댓글은 최대 200자 까지 입력이 가능합니다.";
                        state.isShowModal = true;
                    } else {
                        const param: types.ReqBoardActionComment = {
                            nickname: form_state.nickName,
                            content: comment_state.content,
                            pw: comment_state.pw,
                        };

                        const res = await apiService.boardActionComment.modify(comment_state.idx, param);
                        if (res.returnCode === 0) {
                            item.content = comment_state.content;
                            comment_state.mode = "";

                            comment_state.idx = 0;
                            comment_state.content = "";
                            comment_state.pw = "";
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "비밀번호를 입력해주세요";
                    state.isShowModal = true;
                }
            };

            const confirmCommentRemove = async (idx: number) => {
                comment_state2.idx = idx;
                state.modalTab = 4;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?</br> 댓글 작성 시, 입력한 비밀번호를 입력해주세요.";
                state.isShowModal = true;
            };

            const commentRemove = async (pw: string) => {
                if (pw === "") {
                    state.modalTab2 = 8;
                    state.modalTitle2 = "알림";
                    state.modalContent2 = "비밀번호를 입력해주세요.";
                    state.isShowModal2 = true;
                } else {
                    const param: types.ReqBoardCommentForRemove = {
                        pw: pw,
                    };

                    const res = await apiService.boardActionComment.remove(comment_state2.idx, param);
                    if (res.returnCode === 0) {
                        await getComments();
                        state.modalTab = 8;
                        state.modalTitle = "안내";
                        state.modalContent = "댓글이 삭제 되었습니다.";
                        state.isShowModal = true;
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const commentCancel = () => {
                comment_state.mode = "";
                comment_state.idx = 0;
                comment_state.content = "";
                comment_state.pw = "";
            };

            const edit = (item: any) => {
                state.isShowBtn = true;
                comment_state.idx = item.idx;
                comment_state.mode = "";
            };

            const hasAuthForAdmin = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin == true &&
                            user.roles != null &&
                            user.roles.some((item: types.RoleVO) => item.key.indexOf("activity") > -1)))
                )
                    return true;
                else return false;
            };

            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin == true &&
                            user.roles != null &&
                            user.roles.some((item: types.RoleVO) => item.key.indexOf("activity") > -1)) ||
                        user.userInfo.hasAuth)
                )
                    state.hasAuth = true;
            };

            const showImgModal = (imgUrl: string) => {
                state.modalTab = 11;
                state.modalTitle = "이미지";
                state.modalContent = imgUrl;
                state.isShowModal = true;
            };

            return {
                state,
                router,
                changeTab,
                subMenuTab,
                closeModal,
                closeModal2,
                handlePageChange,
                isDelete,
                CommonUtils,
                callBackModal,
                downloadFile,
                form_state,
                addComment,
                user,
                comment_state,
                commentSave,
                commentModify,
                confirmCommentRemove,
                commentCancel,
                edit,
                hasAuthForAdmin,
                hasAuth,
                showImgModal,
            };
        },
    };
</script>
<style scoped>
    .tit_wrap img {
        vertical-align: unset;
    }
    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }

    .file_list_wrap > div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .file_list_wrap img.file_item {
        width: 100px;
        height: 100px;
        object-fit: contain;
        cursor: pointer;
    }

    .sub_page_con_view.con_view .con_table_wrap .content * {
        max-width: 100% !important;
    }
</style>
